import React from 'react';
import { rule } from '@atlaskit/adf-schema';
import { ACTION, ACTION_SUBJECT, ACTION_SUBJECT_ID, EVENT_TYPE, INPUT_METHOD } from '@atlaskit/editor-common/analytics';
import { toolbarInsertBlockMessages as messages } from '@atlaskit/editor-common/messages';
import { IconDivider } from '@atlaskit/editor-common/quick-insert';
import { insertHorizontalRule } from './commands';
import inputRulePlugin from './pm-plugins/input-rule';
import keymapPlugin from './pm-plugins/keymap';
export var rulePlugin = function rulePlugin(_ref) {
  var _api$analytics;
  var api = _ref.api;
  return {
    name: 'rule',
    nodes: function nodes() {
      return [{
        name: 'rule',
        node: rule
      }];
    },
    actions: {
      insertHorizontalRule: insertHorizontalRule(api === null || api === void 0 || (_api$analytics = api.analytics) === null || _api$analytics === void 0 ? void 0 : _api$analytics.actions)
    },
    pmPlugins: function pmPlugins() {
      return [{
        name: 'ruleInputRule',
        plugin: function plugin(_ref2) {
          var _api$analytics2;
          var schema = _ref2.schema;
          return inputRulePlugin(schema, api === null || api === void 0 || (_api$analytics2 = api.analytics) === null || _api$analytics2 === void 0 ? void 0 : _api$analytics2.actions);
        }
      }, {
        name: 'ruleKeymap',
        plugin: function plugin() {
          var _api$analytics3;
          return keymapPlugin(api === null || api === void 0 || (_api$analytics3 = api.analytics) === null || _api$analytics3 === void 0 ? void 0 : _api$analytics3.actions);
        }
      }];
    },
    pluginsOptions: {
      quickInsert: function quickInsert(_ref3) {
        var formatMessage = _ref3.formatMessage;
        return [{
          id: 'rule',
          title: formatMessage(messages.horizontalRule),
          description: formatMessage(messages.horizontalRuleDescription),
          keywords: ['horizontal', 'rule', 'line', 'hr'],
          priority: 1200,
          keyshortcut: '---',
          icon: function icon() {
            return /*#__PURE__*/React.createElement(IconDivider, null);
          },
          action: function action(insert, state) {
            var _api$analytics4;
            var tr = insert(state.schema.nodes.rule.createChecked());
            api === null || api === void 0 || (_api$analytics4 = api.analytics) === null || _api$analytics4 === void 0 || _api$analytics4.actions.attachAnalyticsEvent({
              action: ACTION.INSERTED,
              actionSubject: ACTION_SUBJECT.DOCUMENT,
              actionSubjectId: ACTION_SUBJECT_ID.DIVIDER,
              attributes: {
                inputMethod: INPUT_METHOD.QUICK_INSERT
              },
              eventType: EVENT_TYPE.TRACK
            })(tr);
            return tr;
          }
        }];
      }
    }
  };
};